import BasicModal, {IBasicModalProps} from "./BasicModal";
import React from "react";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import RouteChoice from "../../../ts/model-factory/basic/route/RouteChoice";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import {getManager} from "../../../ts/manager/Manager";

export default class RegisterYourOrganisationModal extends BasicModal
{
    props: IBasicModalProps;
    hideFooter:boolean = true;
    myProfileChoice:RouteChoice|null

    constructor(props: IBasicModalProps)
    {
        super(props);

        this.props = props;
        this.myProfileChoice = getModelFactory().browseRoute.getDefaultModel().choices.my_profile ?? null;
    }

    renderFooterRight(): React.JSX.Element
    {
        return this.cancelFooterButtons();
    }

    modalTitle(): string
    {
        return "Register your Organisation"
    }


    hideModal(didSubmit?: boolean, withValue?: any)
    {
        super.hideModal(didSubmit, withValue);
        getManager().user.didShowRegisterOrganisationPopup = true;
    }

    renderBody(): React.JSX.Element
    {
        return <>
            <div className="modal-container">
                <div className="modal-instructions">

                    <p className="my-4">The purpose of our website is to allow organisations to share information and
                        requests.</p>

                    <p className="my-4">Many of the website's tools and features will only become available after you
                        have registered an organisation.</p>

                    {!!this.myProfileChoice && <>
                        <p>
                            <RouteChoiceButton
                                routeChoice={this.myProfileChoice}
                                className="btn primary no-transition"
                                label={"Register your Organisation"}
                                onClick={() => this.handleAccept()}
                            />
                        </p>
                    </>}

                </div>


            </div>
        </>
    }
}